import { create } from 'zustand'

const useChatFeedListStore = create((set) => ({
  feedList: [],
  setFeedList: (newFeed) => set((state) => ({ feedList: [...state.feedList, newFeed] })),
  resetFeedList: () => set({ feedList: [] })
}))

export default useChatFeedListStore
